import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const argentineCities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca'];
const argentineNames = ['Martín', 'Lucas', 'Santiago', 'Nicolás', 'Facundo', 'Matías', 'Agustín', 'Tomás', 'Juan', 'Franco', 'Ignacio', 'Gonzalo', 'Ezequiel', 'Maximiliano', 'Federico', 'Rodrigo', 'Pablo'];
function getRandomItem<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)];
}
export function PurchasePopup() {
  const [show, setShow] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase({
        name: getRandomItem(argentineNames),
        city: getRandomItem(argentineCities)
      });
      setShow(true);
      setTimeout(() => {
        setShow(false);
      }, 5000);
    };
    // Show first popup after 5 seconds
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then show every 15-25 seconds
    const interval = setInterval(() => {
      const randomDelay = 15000 + Math.random() * 10000;
      setTimeout(showPopup, randomDelay);
    }, 25000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-105">
      {show && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-4 left-4 z-50 max-w-sm" data-id="element-106">
          <div className="bg-white rounded-lg shadow-2xl border-2 border-green-500 p-4 relative" data-id="element-107">
            <button onClick={() => setShow(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar" data-id="element-108">
              <XIcon className="w-5 h-5" data-id="element-109" />
            </button>

            <div className="flex items-start gap-3" data-id="element-110">
              <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-111">
                <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-112" />
              </div>
              <div data-id="element-113">
                <p className="font-bold text-gray-900 mb-1" data-id="element-114">
                  ¡Alguien acaba de comprar!
                </p>
                <p className="text-sm text-gray-700" data-id="element-115">
                  <span className="font-semibold" data-id="element-116">{currentPurchase.name}</span>{' '}
                  de{' '}
                  <span className="font-semibold" data-id="element-117">{currentPurchase.city}</span>{' '}
                  compró <span className="text-blue-600" data-id="element-118">Basquet 0 a Pro</span>
                </p>
                <p className="text-xs text-gray-500 mt-1" data-id="element-119">Hace unos momentos</p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}